module.exports = __webpack_public_path__ + "img/erp.004f21df.webp";